// extracted by mini-css-extract-plugin
module.exports = {"addRole_box":"AddRole_addRole_box__3tgUi","addRole_title":"AddRole_addRole_title__WRkin","permission":"AddRole_permission__2ylAi","title":"AddRole_title__1bUZj"};